<i2g-rating-icon
  *ngFor="let item of ratingIcons"
  class="rating-icon"
  [id]="item.id"
  [name]="item.name"
  [filled]="item.value <= value"
  [checked]="item.value === value"
  [value]="item.value"
  [readonly]="readonly"
  [size]="iconSize"
  [width]="iconWidth"
  [height]="iconHeight"
  [attr.data-e2e-id]="item.id"
  (clickRatingIcon)="onClickRatingIcon($event)"
>
</i2g-rating-icon>
